import {Navigate, useRoutes} from "react-router-dom";
import {lazy, Suspense} from "react";
import Loader from "../components/Layout/Loader";
import LayoutWithBar from "../layout/LayoutWithBar";

const Dashboard = lazy(() => import("../pages/B_body/Dashboard"));
const Research = lazy(() => import("../pages/B_body/Research"));
const MovieDetails = lazy(() => import("../pages/B_body/MovieDetails"));
const PeopleDetails = lazy(() => import("../pages/B_body/PeopleDetails"));
const Setting = lazy(() => import("../pages/B_body/Setting"));
const SeenMovie = lazy(() => import("../pages/B_body/SeenMovie"));
const Favorite = lazy(() => import("../pages/B_body/Favorite"));


const Router = () => useRoutes([
    {path: "/", element: <Navigate to="dashboard" replace/>},
    {
        path: "/",
        element: <LayoutWithBar/>,
        children: [
            {
                path: "/dashboard",
                element: (
                    <Suspense fallback={<Loader/>}>
                        <Dashboard/>
                    </Suspense>
                ),
            },
            {
                path: "/research/",
                element: (
                    <Suspense fallback={<Loader/>}>
                        <Research/>
                    </Suspense>
                ),
            },
            {
                path: "/research/:query",
                element: (
                    <Suspense fallback={<Loader/>}>
                        <Research/>
                    </Suspense>
                ),
            },
            {
                path: "/favoris",
                element: (
                    <Suspense fallback={<Loader/>}>
                        <Favorite/>
                    </Suspense>
                ),
            },
            {
                path: "/seen-movie",
                element: (
                    <Suspense fallback={<Loader/>}>
                        <SeenMovie/>
                    </Suspense>
                ),
            },
            {
                path: "/movie/:id",
                element: (
                    <Suspense fallback={<Loader/>}>
                        <MovieDetails/>
                    </Suspense>
                ),
            },
            {
                path: "/people/:id",
                element: (
                    <Suspense fallback={<Loader/>}>
                        <PeopleDetails/>
                    </Suspense>
                ),
            },
            {
                path: "/settings",
                element: (
                    <Suspense fallback={<Loader/>}>
                        <Setting/>
                    </Suspense>
                ),
            },
            {path: "*", element: <Navigate to="/404" replace/>},
        ]
    },
    {path: "*", element: <Navigate to="/404" replace/>},
])

export default Router;

/*<Routes>
    <Route path="/" element={<LayoutWithBar/>}>
        <Route path="dashboard" index element={<Dashboard/>}/>
        <Route path="research" element={<Research/>}/>
        <Route path="favoris" element={<Favorite/>}/>
        <Route path="seen-movie" element={<SeenMovie/>}/>
        <Route path="movie/:id" element={<SeenMovie/>}/>
        <Route path="people/:id" element={<SeenMovie/>}/>
        <Route path="settings" element={<Settings/>}/>
    </Route>
</Routes>*/
